export default function timeToMs(time: string){
    const parts = time.split(":");
    const totalMs = ((Number(parts[0]) * 60 * 60 * 1000) + (Number(parts[1]) * 60 * 1000 ) + (Number(parts[2]) * 1000))
    return totalMs
}